import styled from 'styled-components'

export const Flex = styled.div`
  display: grid;
  grid-template-columns: minmax(450px, 450px) minmax(0, 1fr);
  grid-gap: 55px;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;

    & > img {
      grid-row: 1;
      max-width: 400px;
      margin: 0 auto;
    }
  }

  @media (max-width: 600px) {
    & > img {
      max-width: 300px;
    }
  }
`
export const Description = styled.p`
  color: white;
  font-weight: var(--font-light);
  font-size: 18px;
  line-height: 26px;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`
export const NotFoundImage = styled.img`
  width: 100%;
  max-width: 700px;
`
